import { Component } from '@angular/core';
import { ProfileMessages } from '../../locale/profile.messages';

@Component({
  selector: 'app-profile-restricted',
  templateUrl: './profile-restricted.component.html'
})
export class ProfileRestrictedComponent {

  protected readonly eProfileMessages = ProfileMessages;
}
